<template>
  <div class="zcwj">
    <div class="breadcrumb"><a href="/">首页</a>&nbsp;&nbsp;>&nbsp;&nbsp;{{this.columnName}}</div>
    <div class="zcwj_left">
      <h4>文件分类</h4>
      <span v-for="item in name_list" :key="item.file_type_id" :class="{'active':currentSort == item.file_type_id}" @click="active(item.file_type_id)">{{ item.file_type_name }}</span>
    </div>
    <div class="zcwj_right">
      <h2><span>{{zcwj}}</span></h2>
      <el-table :data="file_list" empty-text="暂无数据" border style="width: 100%">
        <el-table-column label="文件标题" width="660">
          <template slot-scope="{row}">
            <span @click="yulan(row.news_img_path)">{{ row.news_art_title }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="news_art_source" label="发文字号" width="300" align="center"></el-table-column>
        <el-table-column label="发布日期" align="center">
          <template slot-scope="{row}">
            <p>{{ row.news_art_time.substr(0,10) }}</p >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page" style="margin-top:95px;margin-bottom:60px;float:left;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="paginations.page_index"
        :page-sizes="paginations.page_sizes"
        :page-size="paginations.page_size"
        :layout="paginations.layout"
        :total="paginations.total"
        >
      </el-pagination>
    </div>

    <el-dialog title="预览" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <p class="arrow">
        <span @click="changePdfPage(0)" class="turn" :class="{grey: currentPage==1}">上一页</span>
        {{currentPage}} / {{pageCount}}
        <span @click="changePdfPage(1)" class="turn" :class="{grey: currentPage==pageCount}">下一页</span>
      </p>
      <pdf :src="src" :page="currentPage" @num-pages="pageCount=$event" @page-loaded="currentPage=$event" @loaded="loadPdfHandler">
      </pdf>
      <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="download(src)">下 载</el-button>
    </span>
    </el-dialog>

  </div>
</template>

<script>
import "@/assets/css/style.css";
import {imgPath,cityId,permissionsId,keywords,description,metatitle,SiteName,SiteDomain} from "@/api/api"
import pdf from 'vue-pdf'
export default {
  components: { pdf },
  name: "zcwj",
  data() {
    return {
      currentSort:0,
      name_list: [],
      file_list: [],
      paginations:{
        page_index:1, //当前页
        total:0, //总数
        page_size:18, //一页显示多少
        layout:'total,prev,pager,next'
      },
      allTableData:[],
      imgPath,
      path:"",
      zcwj:"政策文件",
      dialogVisible: false,
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: 'pdf', // 文件类型
      src: '', // pdf文件地址
      columnName:''
    };
  },
  metaInfo(){
    return{
      title:this.columnName + "_" + metatitle,
      meta:[
        {name:'keywords',content:keywords},
        {name:"description",content:description},
        {name:"SiteName",content:SiteName},
        {name:"SiteDomain",content:SiteDomain},
        {name:"SiteIDCode",content:"辽ICP备16006427号-2"},
        {name:"ColumnName",content:this.columnName},
        {name:"ColumnDescription",content:this.columnName},
        {name:"ColumnKeywords",content:this.columnName},
        {name:"ColumnType",content:this.columnName}
      ]
    }
  },
  created() {
    this.httpPost();
  },
  methods: {
    httpPost() {
      const _this = this;
      this.$http({
        headers:"application/json; charset=utf-8",
        url: "/api/News/GetNewsList",
        data:{
          "city_id": cityId,
          "permissions_id":permissionsId,
          "column_id":_this.$route.params.columnId
        },
        success(res){
          _this.name_list = res.extend.file_type_name_list;
          _this.allTableData = res.extend.file_list;
          _this.columnName = res.extend.columnName;
          _this.setPaginations();
        }
      })
    },
    setPaginations(){
      const _this = this;
      _this.paginations.total = _this.allTableData.length; //数据的数量
      _this.paginations.page_index = 1; //默认显示第一页
      //显示数据
      _this.file_list = _this.allTableData.filter((item,index) => {
        return index < _this.paginations.page_size;
      })
    },
    handleSizeChange(page_size) {
      const _this = this;
      _this.paginations.page_index = 1; //第一页
      _this.paginations.page_size = page_size; //每页先显示多少数据
      _this.file_list = _this.allTableData.filter((item,index) => {
        return index < page_size
      })
    },
    handleCurrentChange(page){
      // 跳转页数
      //获取当前页
      const _this = this;
      let index = _this.paginations.page_size * (page -1);
      //获取总数
      let allData = _this.paginations.page_size * page;
      
      let tablist=[];
      for(let i = index;i<allData;i++) {
        if (_this.allTableData[i]) {
          tablist.push(_this.allTableData[i])
        }
        _this.file_list = tablist
      }
    },
    active(id) {
      const _this = this;
      _this.currentSort  =  id;
      this.$http({
        headers:"application/json; charset=utf-8",
        url: "/api/News/QueryFileByTypeName",
        data:{
          "permissions_id":permissionsId,
          "column_id":_this.$route.params.columnId,
          "file_type_id":id,
          "city_id": cityId,
        },
        success(res){
          _this.file_list = res.extend.file_list;
          _this.allTableData = res.extend.news;
          _this.zcwj = _this.allTableData[0].file_type_name;
          _this.setPaginations();
        }
      })
    },
    yulan(path){
      this.dialogVisible = true;
      this.src = imgPath + path;
    },
    download(path){
      const _this = this;
      _this.path  =  path;
      this.$confirm('是否下载当前文件', '提示', {
      }).then(() => {
        window.location.href = _this.path,
        this.$message({
          type: 'success',
          message: '下载成功!',
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消下载'
        });   
      });
    },
    changePdfPage(val) {
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++
      }
    },
    // pdf加载时
    loadPdfHandler(e) {
      this.currentPage = 1 // 加载的时候先加载第一页
    },
    handleClose(done) {
      this.dialogVisible = false
    }
  },
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/views/zcwj/zcwj.vue